/**
* Get the URL parameter value
*
* @param  name {string} パラメータのキー文字列
* @return  url {url} 対象のURL文字列（任意）
*/
function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


//menu|メニュー表示時のスクロール止め
$(function(){
    // bodyへのoverflow設定：ここで背景のスクロールを固定する。
    var menuBtnCheck = document.getElementById('drawer-checkbox');
    var menuBar = document.getElementById('drawer-open');
    var body = document.getElementsByTagName('body');

    menuBar.onclick = function() { // メニューバーをクリックした時
        if (menuBtnCheck.checked) {
            document.body.style.overflow = 'auto';
        } else {
            document.body.style.overflow = 'hidden';
        }
    }
});

//ドロワーメニュー内施設一覧トグル
$(function(){
    $('.plus').click(function(){
        $(this).toggleClass("show");
    });
});



/*--------------------------------------------------------------------------*
 *  
 *  footerFixed.js
 *  
 *  MIT-style license. 
 *  
 *  2007 Kazuma Nishihata [to-R]
 *  http://blog.webcreativepark.net
 *  
 *--------------------------------------------------------------------------*/

new function(){
	
	var footerId = "footer";
	//メイン
	function footerFixed(){
		//ドキュメントの高さ
		var dh = document.getElementsByTagName("body")[0].clientHeight;
		//フッターのtopからの位置
		document.getElementById(footerId).style.top = "0px";
		var ft = document.getElementById(footerId).offsetTop;
		//フッターの高さ
		var fh = document.getElementById(footerId).offsetHeight;
		//ウィンドウの高さ
		if (window.innerHeight){
			var wh = window.innerHeight;
		}else if(document.documentElement && document.documentElement.clientHeight != 0){
			var wh = document.documentElement.clientHeight;
		}
		if(ft+fh<wh){
			document.getElementById(footerId).style.position = "relative";
			document.getElementById(footerId).style.top = (wh-fh-ft-1)+"px";
		}
	}
	
	//文字サイズ
	function checkFontSize(func){
	
		//判定要素の追加	
		var e = document.createElement("div");
		var s = document.createTextNode("S");
		e.appendChild(s);
		e.style.visibility="hidden"
		e.style.position="absolute"
		e.style.top="0"
		document.body.appendChild(e);
		var defHeight = e.offsetHeight;
		
		//判定関数
		function checkBoxSize(){
			if(defHeight != e.offsetHeight){
				func();
				defHeight= e.offsetHeight;
			}
		}
		setInterval(checkBoxSize,1000)
	}
	
	//イベントリスナー
	function addEvent(elm,listener,fn){
		try{
			elm.addEventListener(listener,fn,false);
		}catch(e){
			elm.attachEvent("on"+listener,fn);
		}
	}

	addEvent(window,"load",footerFixed);
	addEvent(window,"load",function(){
		checkFontSize(footerFixed);
	});
	addEvent(window,"resize",footerFixed);
	
}


//PCfixメニューフッター直前固定
$(function() {
    $(window).on("scroll", function() {
        const scrollHeight = $(document).height();/*ページ全体の高さ*/
        const scrollPosition = $(window).height() + $(window).scrollTop();/*ページの一番上からスクロールされた距離*/
        const footHeight = $(".footer_fixed").height();/*フッターの高さ*/
        if ( scrollHeight - scrollPosition  <= footHeight ) {
            $(".fix_menu").css({
                "height":"80vh",
            });
        } else {
            $(".fix_menu").css({
                "height":"100vh",
            });
        }
    });
});

//画面幅可変時リロード
//$(function(){
//	var timer = false;
//	var prewidth = $(window).width();
//	$(window).resize(function() {
//		if (timer !== false) {
//			clearTimeout(timer);
//		}
//		timer = setTimeout(function() {
//			var nowWidth = $(window).width();
//			if(prewidth !== nowWidth){
//				// リロード
//				location.reload();
//			}
//			prewidth = nowWidth;
//		}, 200);
//	});
//});